import { Texture, TilingSprite } from 'pixi.js';

const TILE = 192;
let grainTexture: Texture | null = null;

function seededRandom(seed: number): () => number {
  let s = seed;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

function buildGrainTexture(): Texture {
  const canvas = document.createElement('canvas');
  canvas.width = TILE;
  canvas.height = TILE;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not create grain texture');

  const imageData = ctx.createImageData(TILE, TILE);
  const rand = seededRandom(731_921);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    const n = rand();
    const tone = 118 + (n - 0.5) * 46;
    data[i] = tone;
    data[i + 1] = tone;
    data[i + 2] = tone;
    data[i + 3] = 10 + n * 34;
  }

  ctx.putImageData(imageData, 0, 0);
  return Texture.from(canvas);
}

function getGrainTexture(): Texture {
  if (!grainTexture) grainTexture = buildGrainTexture();
  return grainTexture;
}

/** Tiled film-grain overlay — sits above flat field fills, below foreground art. */
export function createGrainOverlay(): TilingSprite {
  const sprite = new TilingSprite({
    texture: getGrainTexture(),
    width: 1,
    height: 1,
  });
  sprite.eventMode = 'none';
  sprite.blendMode = 'soft-light';
  sprite.alpha = 0.55;
  return sprite;
}

export function resizeGrainOverlay(sprite: TilingSprite, w: number, h: number): void {
  sprite.width = w;
  sprite.height = h;
}
